module.exports = __webpack_public_path__ + "static/img/cd.cd346cdc.svg";